import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Root, Portal, Overlay, Close, Content, Title } from '@radix-ui/react-dialog';
import closeIcon from '@/assets/icons/close.svg';
import styles from './LandingSiteFormsPage.module.scss';

interface PopupDialogProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
}

/**
 * The one size every change on this screen is made at - pick a file, fix an address, correct a bank
 * number: a small panel in the middle of the screen. The shared MainDialogLayout is a
 * near-fullscreen sheet, which is right for a form with sections in it and far too much room for
 * any of these.
 */
const PopupDialog = ({ title, onClose, children }: PopupDialogProps) => {
  const { t } = useTranslation();

  return (
    <Root open onOpenChange={(isOpen: boolean) => { if (!isOpen) onClose(); }}>
      <Portal>
        <Overlay className={styles.popupOverlay} />
        <Content className={styles.popupContent} aria-describedby={undefined}>
          <Close className={styles.popupClose} aria-label={t('close')}>
            <img src={closeIcon} alt="" />
          </Close>
          <Title className={`heading-h4-semibold ${styles.popupTitle}`}>{title}</Title>
          {children}
        </Content>
      </Portal>
    </Root>
  );
};

export default PopupDialog;
